import * as React from 'react';
import Container from '@mui/material/Container';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import MarloweVideo from './MarloweVideo.tsx';

export default function MarloweGallery() {
  return (
    <Container sx={{
      minWidth: "400",
      display: 'flex',
    }}>
      <ImageList
        variant="quilted"
        cols={4}
        sx={{width:"100%"}}
      >
        <ImageListItem key="MarloweVideo" cols={4} rows={2}>
          <MarloweVideo />  
        </ImageListItem>
      </ImageList>
    </Container>
  );
}
